import Actions from '../../odata/actions';

const actions = new Actions('csvOrder', 'csvOrders');

export default actions;
